import React from "react";

export const DashboardIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 21.25"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.5,16.306h9.778V4.5H4.5Zm0,9.444h9.778V18.667H4.5Zm12.222,0H26.5V13.944H16.722Zm0-21.25v7.083H26.5V4.5Z"
      transform="translate(-4.5 -4.5)"
    />
  </svg>
);

export const ProjectIcon = ({ className = "ml-3 mr-1 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.491,22.5h-.848V1.125A1.075,1.075,0,0,0,16.625,0H2.375A1.075,1.075,0,0,0,1.357,1.125V22.5H.509A.538.538,0,0,0,0,23.063V24H19v-.937A.538.538,0,0,0,18.491,22.5ZM5.429,3.563A.538.538,0,0,1,5.938,3h1.7a.538.538,0,0,1,.509.563V5.438A.538.538,0,0,1,7.634,6h-1.7a.538.538,0,0,1-.509-.562Zm0,4.5A.538.538,0,0,1,5.938,7.5h1.7a.538.538,0,0,1,.509.563V9.938a.538.538,0,0,1-.509.563h-1.7a.538.538,0,0,1-.509-.562ZM7.634,15h-1.7a.538.538,0,0,1-.509-.562V12.563A.538.538,0,0,1,5.938,12h1.7a.538.538,0,0,1,.509.563v1.875A.538.538,0,0,1,7.634,15Zm3.223,7.5H8.143V18.563A.538.538,0,0,1,8.652,18h1.7a.538.538,0,0,1,.509.563Zm2.714-8.062a.538.538,0,0,1-.509.563h-1.7a.538.538,0,0,1-.509-.562V12.563A.538.538,0,0,1,11.366,12h1.7a.538.538,0,0,1,.509.563Zm0-4.5a.538.538,0,0,1-.509.563h-1.7a.538.538,0,0,1-.509-.562V8.063a.538.538,0,0,1,.509-.562h1.7a.538.538,0,0,1,.509.563Zm0-4.5A.538.538,0,0,1,13.063,6h-1.7a.538.538,0,0,1-.509-.562V3.563A.538.538,0,0,1,11.366,3h1.7a.538.538,0,0,1,.509.563Z"
    />
  </svg>
);

export const AssetsIcon = ({ className = "ml-3 Iconbroker", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27.678 24.602"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M26.909,13.839H23.065v4.613l-1.538-1.024-1.538,1.024V13.839H16.145a.771.771,0,0,0-.769.769v9.226a.771.771,0,0,0,.769.769H26.909a.771.771,0,0,0,.769-.769V14.608A.771.771,0,0,0,26.909,13.839ZM8.457,10.764H19.221a.771.771,0,0,0,.769-.769V.769A.771.771,0,0,0,19.221,0H15.377V4.613L13.839,3.589,12.3,4.613V0H8.457a.771.771,0,0,0-.769.769V9.995A.771.771,0,0,0,8.457,10.764Zm3.075,3.075H7.688v4.613L6.151,17.428,4.613,18.452V13.839H.769A.771.771,0,0,0,0,14.608v9.226a.771.771,0,0,0,.769.769H11.532a.771.771,0,0,0,.769-.769V14.608A.771.771,0,0,0,11.532,13.839Z"
    />
  </svg>
);

export const AvailableIcon = ({ className = "ml-3 mr-1 Iconhome", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.779,3.223A11,11,0,1,0,3.85,19.367h.009A11,11,0,0,0,18.779,3.223Zm-4.112,9.609C11,12.832,11,9.165,7.333,9.165c-2.292,0-3.153,1.435-4.368,2.512h0A8.068,8.068,0,0,1,19.039,10.32c-1.219,1.077-2.081,2.512-4.373,2.512Z"
    />
  </svg>
);

export const HomeIcon = ({ className = "ml-3 Iconbroker", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 19"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.628,7.183,4.666,13.623v6.951a.733.733,0,0,0,.778.679l5.447-.012a.733.733,0,0,0,.774-.679V16.5a.733.733,0,0,1,.778-.679h3.111a.733.733,0,0,1,.778.679V20.56a.638.638,0,0,0,.227.481.839.839,0,0,0,.551.2l5.445.013a.733.733,0,0,0,.778-.679V13.619l-8.96-6.436A.661.661,0,0,0,13.628,7.183ZM27.784,11.56,23.72,8.637V2.763a.55.55,0,0,0-.583-.509H20.415a.55.55,0,0,0-.583.509v3.08L15.48,2.718a2.6,2.6,0,0,0-2.965,0L.211,11.56a.466.466,0,0,0-.078.717l1.239,1.315a.612.612,0,0,0,.395.183.643.643,0,0,0,.427-.114L13.628,5.444a.661.661,0,0,1,.744,0l11.434,8.218a.643.643,0,0,0,.821-.068l1.239-1.315A.466.466,0,0,0,28,11.9a.494.494,0,0,0-.212-.344Z"
      transform="translate(0.001 -2.254)"
    />
  </svg>
);

export const LedgerIcon = ({ className = "ml-3 mr-1 Iconpayable", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 22"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.8.137,15,2.062,12.45.137a.8.8,0,0,0-.9,0L9,2.062,6.45.137a.8.8,0,0,0-.9,0L3,2.062,1.2.137A.756.756,0,0,0,0,.687V21.31a.756.756,0,0,0,1.2.55L3,19.935l2.55,1.925a.8.8,0,0,0,.9,0L9,19.935l2.55,1.925a.8.8,0,0,0,.9,0L15,19.935l1.8,1.925a.757.757,0,0,0,1.2-.55V.687a.756.756,0,0,0-1.2-.55ZM15,15.466a.361.361,0,0,1-.375.344H3.375A.361.361,0,0,1,3,15.466v-.687a.361.361,0,0,1,.375-.344h11.25a.361.361,0,0,1,.375.344Zm0-4.125a.361.361,0,0,1-.375.344H3.375A.361.361,0,0,1,3,11.342v-.687a.361.361,0,0,1,.375-.344h11.25a.361.361,0,0,1,.375.344Zm0-4.125a.361.361,0,0,1-.375.344H3.375A.361.361,0,0,1,3,7.217V6.53a.361.361,0,0,1,.375-.344h11.25A.361.361,0,0,1,15,6.53Z"
      transform="translate(0 0.002)"
    />
  </svg>
);

export const ChartIcon = ({ className = "ml-3 Iconpayable", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 20"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M24.395,21.167v1.111A2.223,2.223,0,0,1,22.184,24.5H6.711A2.216,2.216,0,0,1,4.5,22.278V6.722A2.216,2.216,0,0,1,6.711,4.5H22.184a2.223,2.223,0,0,1,2.211,2.222V7.833H14.447a2.216,2.216,0,0,0-2.211,2.222v8.889a2.216,2.216,0,0,0,2.211,2.222Zm-9.947-2.222H25.5V10.056H14.447Zm4.421-2.778A1.667,1.667,0,1,1,20.526,14.5,1.66,1.66,0,0,1,18.868,16.167Z"
      transform="translate(-4.5 -4.5)"
    />
  </svg>
);

export const TaxIcon = ({ className = "ml-3 Icontax", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 25"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.88,15.3V25.72h-7.5V23.637H9.88V25.72h-7V15.3Zm-4.525-1.9A6.02,6.02,0,0,0,17.4,10.071c-.989-.856-2.158-1.018-3.515-1.539H13.88v-3.3l.262-.073.573-.221a5.343,5.343,0,0,1,.628-.189,1.98,1.98,0,0,1,.443-.072,3.3,3.3,0,0,1,.706.095c.284.072.587.149.894.238s.607.178.884.243a2.917,2.917,0,0,0,.67.089,4.655,4.655,0,0,0,.941-.134V1.439a3.3,3.3,0,0,1-.941.192,2.7,2.7,0,0,1-.676-.1c-.277-.055-.561-.141-.882-.238q-.429-.134-.866-.232a2.564,2.564,0,0,0-.64-.1,4.522,4.522,0,0,0-2,.446V.72h-1V8.533h-.031c-1.346.521-2.524.712-3.512,1.568a6.071,6.071,0,0,0-1.959,3.261.82.82,0,0,0-.958.9H20.4c0-1.042-1.05-.857-1.05-.857Z"
      transform="translate(-2.88 -0.72)"
    />
  </svg>
);

export const LoanIcon = ({ className = "ml-3 Iconhome", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 18"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M28.092,23.012H17.207a7.144,7.144,0,0,0,.725-1.8h10.16a.9.9,0,0,1,0,1.8Zm0-2.7H18.1a6.634,6.634,0,0,0,0-1.8h9.988a.9.9,0,0,1,0,1.8Zm0-2.7H17.932a7.177,7.177,0,0,0-.725-1.8H28.092a.9.9,0,0,1,0,1.8Zm0-2.7H16.6a7.142,7.142,0,0,0-2.106-1.8h13.6a.9.9,0,0,1,0,1.8Zm0-2.7H13.87a.9.9,0,0,1,0-1.8H28.092a.9.9,0,0,1,0,1.8Zm0-2.7H13.87a.9.9,0,0,1,0-1.8H28.092a.9.9,0,0,1,0,1.8Zm-10.667,9.9a6.223,6.223,0,1,1-6.222-6.3A6.262,6.262,0,0,1,17.425,19.412Zm-4.02.685a1.927,1.927,0,0,0-.35-.562,2.3,2.3,0,0,0-.494-.41,5.674,5.674,0,0,0-.566-.307q-.282-.131-.566-.256a3.678,3.678,0,0,1-.5-.258,1.258,1.258,0,0,1-.35-.315.686.686,0,0,1-.131-.419.834.834,0,0,1,.058-.308.647.647,0,0,1,.178-.249.858.858,0,0,1,.3-.162,1.319,1.319,0,0,1,.417-.058,1.973,1.973,0,0,1,.561.075,3.181,3.181,0,0,1,.45.168q.195.092.328.17a.457.457,0,0,0,.195.077.135.135,0,0,0,.1-.033.222.222,0,0,0,.055-.107,1.069,1.069,0,0,0,.028-.185c.005-.076.008-.168.008-.277s0-.179-.005-.244a1.29,1.29,0,0,0-.019-.164.516.516,0,0,0-.033-.1.425.425,0,0,0-.076-.094.884.884,0,0,0-.228-.14,2.612,2.612,0,0,0-.394-.15,3.455,3.455,0,0,0-.477-.106c-.035-.005-.07,0-.1-.008v-.931h-.875v.931a3.17,3.17,0,0,0-.468.1,2.188,2.188,0,0,0-.766.391,1.884,1.884,0,0,0-.516.657,2.334,2.334,0,0,0-.059,1.7,1.935,1.935,0,0,0,.348.565,2.288,2.288,0,0,0,.485.41,5.01,5.01,0,0,0,.561.307c.193.09.38.175.561.256a3.715,3.715,0,0,1,.485.258,1.34,1.34,0,0,1,.348.315.688.688,0,0,1,.133.425.955.955,0,0,1-.077.39.788.788,0,0,1-.225.292,1.051,1.051,0,0,1-.357.183,1.629,1.629,0,0,1-.478.065,2.474,2.474,0,0,1-.714-.093,3.249,3.249,0,0,1-.531-.206,3.5,3.5,0,0,1-.364-.205.462.462,0,0,0-.22-.093.16.16,0,0,0-.1.031.2.2,0,0,0-.067.1.882.882,0,0,0-.036.192c-.008.079-.012.176-.012.292a2.018,2.018,0,0,0,.03.4.417.417,0,0,0,.1.211,1.184,1.184,0,0,0,.236.167,2.416,2.416,0,0,0,.408.181,4.118,4.118,0,0,0,.564.148,3.7,3.7,0,0,0,.692.06l.032,0v.867h.874v-.983c.042-.011.086-.016.127-.028a2.491,2.491,0,0,0,.844-.436,2.078,2.078,0,0,0,.572-.722,2.274,2.274,0,0,0,.21-1.006,1.987,1.987,0,0,0-.132-.76ZM16.6,23.912H28.092a.9.9,0,0,1,0,1.8h-13.6a7.142,7.142,0,0,0,2.106-1.8Z"
      transform="translate(-4.981 -7.712)"
    />
  </svg>
);

export const ReportIcon = ({ className = "ml-3 Iconpayable", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.029,4.913V20.394a.675.675,0,0,1-.673.673h0a.675.675,0,0,1-.673-.673V6.452H4.913A1.537,1.537,0,0,0,3.375,7.99V21.837a1.537,1.537,0,0,0,1.538,1.538H21.889a1.487,1.487,0,0,0,1.486-1.486V4.913a1.537,1.537,0,0,0-1.538-1.538l-13.365.1A1.378,1.378,0,0,0,7.029,4.913ZM10.2,6.452H14.24a.675.675,0,0,1,.673.673h0a.675.675,0,0,1-.673.673H10.2a.675.675,0,0,1-.673-.673h0A.675.675,0,0,1,10.2,6.452Zm0,7.692h7.115a.675.675,0,0,1,.673.673h0a.675.675,0,0,1-.673.673H10.2a.675.675,0,0,1-.673-.673h0A.675.675,0,0,1,10.2,14.144Zm9.423,5.192H10.2a.675.675,0,0,1-.673-.673h0a.675.675,0,0,1,.673-.673h9.423a.675.675,0,0,1,.673.673h0A.675.675,0,0,1,19.625,19.337Zm0-7.692H10.2a.675.675,0,0,1-.673-.673h0A.675.675,0,0,1,10.2,10.3h9.423a.675.675,0,0,1,.673.673h0A.675.675,0,0,1,19.625,11.644Z"
      transform="translate(-3.375 -3.375)"
    />
  </svg>
);

export const PayrollIcon = ({ className = "ml-3 Iconpayable", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 21.5"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.624,3.11a4.624,4.624,0,0,0-2.8-2.733A14.548,14.548,0,0,0,14.318,0H7.663A15.112,15.112,0,0,0,3.172.358,4.624,4.624,0,0,0,.376,3.1,13.843,13.843,0,0,0,0,7.492v6.515A14.146,14.146,0,0,0,.367,18.4a4.624,4.624,0,0,0,2.8,2.733,14.788,14.788,0,0,0,4.492.367h6.673a15.08,15.08,0,0,0,4.492-.358,4.624,4.624,0,0,0,2.8-2.742A13.843,13.843,0,0,0,22,14.008V7.51a13.876,13.876,0,0,0-.376-4.4ZM15.968,7.259l-.852.833A.466.466,0,0,1,14.5,8.1,4.646,4.646,0,0,0,11.55,7.044c-.889,0-1.778.287-1.778,1.084s.953,1.075,2.053,1.479c1.925.627,3.52,1.416,3.52,3.262,0,2.008-1.6,3.388-4.2,3.54l-.238,1.075a.447.447,0,0,1-.44.35H8.827l-.082-.009A.448.448,0,0,1,8.4,17.3l.257-1.138a6.037,6.037,0,0,1-2.64-1.407v-.009a.423.423,0,0,1,0-.609l.917-.869a.457.457,0,0,1,.614,0,4.489,4.489,0,0,0,3.107,1.183c1.192,0,1.989-.493,1.989-1.273s-.807-.986-2.328-1.541C8.7,11.068,7.168,10.271,7.168,8.406c0-2.169,1.843-3.226,4.024-3.325l.229-1.1a.438.438,0,0,1,.44-.341h1.632l.092.009a.429.429,0,0,1,.339.511l-.248,1.228A6.924,6.924,0,0,1,15.95,6.632l.018.018a.421.421,0,0,1,0,.609Z"
    />
  </svg>
);

export const EmployeeIcon = ({ className = "ml-3 mr-1 Iconhome", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22.268 22.268"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.134,3A11.134,11.134,0,1,0,25.268,14.134,11.138,11.138,0,0,0,14.134,3Zm0,3.34a3.34,3.34,0,1,1-3.34,3.34A3.336,3.336,0,0,1,14.134,6.34Zm0,15.81a8.017,8.017,0,0,1-6.68-3.585c.033-2.216,4.454-3.429,6.68-3.429s6.647,1.214,6.68,3.429a8.017,8.017,0,0,1-6.68,3.585Z"
      transform="translate(-3 -3)"
    />
  </svg>
);

export const BrokerIcon = ({ className = "ml-3 Iconbroker", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 18"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5,3.375A1.789,1.789,0,0,0,6.874,1.688,1.789,1.789,0,0,0,5,0,1.789,1.789,0,0,0,3.124,1.688,1.789,1.789,0,0,0,5,3.375Zm15,0a1.789,1.789,0,0,0,1.875-1.687,1.885,1.885,0,0,0-3.75,0A1.789,1.789,0,0,0,20,3.375Zm4.91,13.082L23.19,12.589l-1.605,1.631-.078.64,1.082,2.433a1.256,1.256,0,0,0,1.16.707,1.333,1.333,0,0,0,.465-.081A1.09,1.09,0,0,0,24.909,16.457ZM23.573,9.081l-.723-2.82a2.356,2.356,0,0,0-1.465-1.579,2.647,2.647,0,0,0-2.191.116,3.963,3.963,0,0,0-1.879,2.088l-.441,1.192-.625.359V5.063a.6.6,0,0,0-.625-.562H9.374a.6.6,0,0,0-.625.563V8.438L8.12,8.079,7.679,6.887A3.935,3.935,0,0,0,5.8,4.8a2.648,2.648,0,0,0-2.191-.116A2.356,2.356,0,0,0,2.144,6.261l-.719,2.82a2.093,2.093,0,0,0,.562,1.993l2.625,2.668L5.007,17a1.211,1.211,0,0,0,1.242,1c.047,0,.09,0,.137-.007a1.158,1.158,0,0,0,1.105-1.241L7.1,13.489a2.148,2.148,0,0,0-.609-1.23L4.8,10.536l.687-2.471.266.717a2.311,2.311,0,0,0,.957,1.146l2,1.143a1.8,1.8,0,0,0,.672.176h6.25a1.8,1.8,0,0,0,.672-.176l2-1.143a2.3,2.3,0,0,0,.957-1.146l.266-.717.687,2.471L18.51,12.259a2.148,2.148,0,0,0-.609,1.23l-.395,3.262a1.161,1.161,0,0,0,1.105,1.241c.047,0,.09.007.137.007a1.211,1.211,0,0,0,1.242-1l.395-3.255,2.625-2.668a2.1,2.1,0,0,0,.562-1.993ZM1.808,12.589.089,16.457a1.09,1.09,0,0,0,.7,1.462,1.3,1.3,0,0,0,1.625-.626l1.082-2.433-.078-.64L1.808,12.589Z"
      transform="translate(0.001)"
    />
  </svg>
);

export const LeadIcon = ({ className = "ml-3 Iconbroker", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.808 16.122"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <g transform="translate(-2.215 -7.748)">
      <path
        fill="currentColor"
        d="M21.043,20.152c-.619-.221-1.63-.232-2.077-.4A2.935,2.935,0,0,1,18,19.3a5.941,5.941,0,0,1-.16-1.575,2.544,2.544,0,0,0,.547-.774,8.6,8.6,0,0,0,.265-1.519s.365.155.508-.575c.122-.63.354-.961.293-1.425s-.32-.354-.32-.354a4.137,4.137,0,0,0,.32-2.066,3.306,3.306,0,0,0-3.569-3.265,3.318,3.318,0,0,0-3.575,3.265,4.2,4.2,0,0,0,.315,2.066s-.26-.111-.32.354.166.8.293,1.425c.144.735.508.575.508.575a8.68,8.68,0,0,0,.265,1.519,2.544,2.544,0,0,0,.547.774,5.941,5.941,0,0,1-.16,1.575,2.825,2.825,0,0,1-.961.442c-.442.171-1.453.193-2.077.414a3.9,3.9,0,0,0-2.531,3.713H23.568A3.892,3.892,0,0,0,21.043,20.152Z"
        transform="translate(-1.28 0)"
      />
      <path
        fill="currentColor"
        d="M8.21,18.2a3.751,3.751,0,0,0,1.845-.514c-.856-1.3-.392-2.812-.569-4.227a2.331,2.331,0,0,0-2.58-2.254H6.884a2.338,2.338,0,0,0-2.558,2.254c-.177,1.409.315,3.094-.564,4.227a3.471,3.471,0,0,0,1.851.459h0a2.8,2.8,0,0,1-.055.928,1.4,1.4,0,0,1-.663.3,12.82,12.82,0,0,0-1.431.4,2.326,2.326,0,0,0-1.249,2.055H6.652A3.969,3.969,0,0,1,8.42,20.186,3.71,3.71,0,0,1,9.784,19.9s.21-.332-.481-.459a4.71,4.71,0,0,1-1.061-.37C8.138,18.949,8.21,18.2,8.21,18.2Z"
        transform="translate(0 -0.741)"
      />
      <path
        fill="currentColor"
        d="M25.653,18.2a3.751,3.751,0,0,1-1.845-.514c.856-1.3.392-2.812.569-4.227a2.331,2.331,0,0,1,2.58-2.254h.022a2.338,2.338,0,0,1,2.558,2.254c.177,1.409-.315,3.094.564,4.227a3.471,3.471,0,0,1-1.851.459h0a2.8,2.8,0,0,0,.055.928,1.4,1.4,0,0,0,.663.3,12.82,12.82,0,0,1,1.431.4,2.326,2.326,0,0,1,1.249,2.055H27.211a3.969,3.969,0,0,0-1.768-1.646,3.71,3.71,0,0,0-1.365-.287s-.21-.332.481-.459a4.71,4.71,0,0,0,1.061-.37C25.725,18.949,25.653,18.2,25.653,18.2Z"
        transform="translate(-4.625 -0.741)"
      />
    </g>
  </svg>
);

export const LeadsIcon = BrokerIcon;

export const TaskIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 19"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M0,0V19H21V9.256L18,11.97v4.316H3V2.714H13.77L16.77,0ZM21,0,12,8.143,9,5.429,6,8.143l6,5.429L24,2.714Z"
    />
  </svg>
);

export const PersonIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.5,14.5a5,5,0,1,0-5-5A5.015,5.015,0,0,0,14.5,14.5Zm0,2.5c-3.312,0-10,1.688-10,5v2.5h20V22C24.5,18.688,17.812,17,14.5,17Z"
      transform="translate(-4.5 -4.5)"
    />
  </svg>
);

export const DepreciationIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 23"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.722,21.4h2.111V7.6H8.722ZM12.944,26h2.111V3H12.944ZM4.5,16.8H6.611V12.2H4.5Zm12.667,4.6h2.111V7.6H17.167Zm4.222-9.2v4.6H23.5V12.2Z"
      transform="translate(-4.5 -3)"
    />
  </svg>
);

export const MaintenanceIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.529,17,16.5,11.97a3.19,3.19,0,0,0-3.669-.6l-4.58-4.58V4.125L2.748,0,0,2.75l4.125,5.5H6.792l4.58,4.58a3.2,3.2,0,0,0,.6,3.669L17,21.53a1.6,1.6,0,0,0,2.264,0l2.264-2.264A1.605,1.605,0,0,0,21.529,17ZM14.251,9.667A4.521,4.521,0,0,1,17.469,11l.834.834a6.082,6.082,0,0,0,1.882-1.267,6.179,6.179,0,0,0,1.628-5.873.514.514,0,0,0-.864-.236l-3.2,3.2-2.917-.485-.486-2.917,3.2-3.2A.519.519,0,0,0,17.3.185a6.19,6.19,0,0,0-5.869,1.628,6.088,6.088,0,0,0-1.77,4.451l3.528,3.527A4.681,4.681,0,0,1,14.251,9.667ZM9.786,13.19,7.35,10.754.8,17.306a2.749,2.749,0,0,0,3.888,3.888L10,15.884a4.614,4.614,0,0,1-.215-2.694ZM2.748,20.279A1.031,1.031,0,1,1,3.78,19.248,1.034,1.034,0,0,1,2.748,20.279Z"
      transform="translate(0.004)"
    />
  </svg>
);

export const TodoListIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 20"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.544,2.411a.568.568,0,0,0-.8,0L2.762,5.342,1.7,4.318a.568.568,0,0,0-.8,0l-.736.728a.551.551,0,0,0,0,.787L2.4,8.027a.6.6,0,0,0,.825,0L3.953,7.3,7.337,3.962a.555.555,0,0,0,0-.787Zm0,7.369a.568.568,0,0,0-.8,0l-2.985,2.95L1.7,11.707a.568.568,0,0,0-.8,0l-.736.726a.551.551,0,0,0,0,.787l2.225,2.2a.6.6,0,0,0,.825,0l.736-.726L7.336,11.35a.551.551,0,0,0,0-.782ZM3,17.8a2.223,2.223,0,1,0,0,4.444A2.222,2.222,0,1,0,3,17.8Zm20.25.741H9.75a.745.745,0,0,0-.75.741v1.481a.745.745,0,0,0,.75.741h13.5a.745.745,0,0,0,.75-.741V19.285A.745.745,0,0,0,23.25,18.544Zm0-14.814H9.75A.745.745,0,0,0,9,4.471V5.953a.745.745,0,0,0,.75.741h13.5A.745.745,0,0,0,24,5.953V4.471A.745.745,0,0,0,23.25,3.731Zm0,7.407H9.75a.745.745,0,0,0-.75.741V13.36a.745.745,0,0,0,.75.741h13.5A.745.745,0,0,0,24,13.36V11.878A.745.745,0,0,0,23.25,11.138Z"
      transform="translate(0 -2.248)"
    />
  </svg>
);

export const WhatsappIcon = ({ className = "ml-3 Icondashboard", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91C2.13 13.66 2.59 15.36 3.45 16.86L2.05 22L7.3 20.63C8.75 21.41 10.38 21.83 12.04 21.83C17.5 21.83 21.95 17.38 21.95 11.92C21.95 9.27 20.92 6.78 19.05 4.91C17.18 3.03 14.69 2 12.04 2ZM12.05 3.67C14.25 3.67 16.31 4.53 17.87 6.09C19.42 7.65 20.28 9.71 20.28 11.92C20.28 16.46 16.59 20.16 12.05 20.16C10.58 20.16 9.15 19.77 7.9 19.03L7.54 18.82L4.42 19.64L5.25 16.6L5.02 16.23C4.21 14.93 3.79 13.44 3.79 11.91C3.79 7.37 7.5 3.67 12.05 3.67ZM8.79 7.39C8.61 7.39 8.31 7.46 8.07 7.72C7.83 7.98 7.15 8.62 7.15 9.93C7.15 11.24 8.1 12.51 8.24 12.69C8.37 12.87 10.08 15.51 12.71 16.64C13.33 16.91 13.82 17.07 14.2 17.19C14.83 17.39 15.39 17.36 15.85 17.29C16.36 17.21 17.41 16.65 17.63 16.03C17.85 15.41 17.85 14.88 17.78 14.77C17.72 14.66 17.54 14.6 17.27 14.47C17 14.33 15.69 13.68 15.45 13.59C15.21 13.5 15.03 13.46 14.86 13.73C14.69 13.99 14.19 14.6 14.04 14.77C13.89 14.95 13.74 14.97 13.47 14.83C13.2 14.7 12.33 14.41 11.3 13.49C10.5 12.78 9.96 11.9 9.81 11.64C9.66 11.37 9.8 11.23 9.93 11.1C10.06 10.97 10.21 10.77 10.35 10.61C10.49 10.45 10.54 10.33 10.63 10.15C10.72 9.98 10.67 9.83 10.6 9.69C10.54 9.56 10.01 8.28 9.8 7.74C9.58 7.22 9.36 7.29 9.19 7.29C9.04 7.28 8.86 7.28 8.79 7.39Z"
    />
  </svg>
);

export const AnalyticsIcon = ({ className = "ml-3 Iconhome", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
    />
  </svg>
);

export const PayableIcon = ({ className = "ml-3 Iconpayable", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21.51 22"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.371,22H3.551a.842.842,0,0,1-.85-1.082l.135-.618H4.717a1.453,1.453,0,0,0,1.346-1.083l.967-4.209a1.455,1.455,0,0,1,1.345-1.082h.8q5.163,0,8.031-2.145a6.693,6.693,0,0,0,2.871-5.624A5.424,5.424,0,0,0,19.545,3.6c0-.015-.015-.028-.015-.042l.123.069A4.223,4.223,0,0,1,21.207,5.29a5.385,5.385,0,0,1,.543,2.558,6.676,6.676,0,0,1-2.874,5.624c-1.908,1.416-4.592,2.13-8.026,2.13h-.818A1.454,1.454,0,0,0,8.685,16.69l-.968,4.221a1.442,1.442,0,0,1-1.335,1.073ZM3.939,19.53H1.118a.843.843,0,0,1-.85-1.082L4.24,1.084A1.452,1.452,0,0,1,5.586,0h5.873a18.345,18.345,0,0,1,3.314.265,6.927,6.927,0,0,1,2.438.907,4.211,4.211,0,0,1,1.542,1.667A5.559,5.559,0,0,1,19.284,5.4a6.637,6.637,0,0,1-2.874,5.609c-1.908,1.431-4.593,2.132-8.027,2.132h-.8a1.451,1.451,0,0,0-1.343,1.072l-.964,4.207A1.452,1.452,0,0,1,3.924,19.5ZM10.7,3.608H9.782a1.449,1.449,0,0,0-1.345,1.08L7.593,8.373a.841.841,0,0,0,.845,1.081h.7a5.9,5.9,0,0,0,3.543-.936,3.131,3.131,0,0,0,1.267-2.669,1.886,1.886,0,0,0-.818-1.687,4.375,4.375,0,0,0-2.44-.555H10.7Z"
      transform="translate(-0.241)"
    />
  </svg>
);

export const BellIcon = ({ className = "Icontaxbell", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.664 21.657"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.832,21.657A2.759,2.759,0,0,0,12.64,18.95H7.024A2.759,2.759,0,0,0,9.832,21.657Zm9.454-6.333c-.848-.878-2.435-2.2-2.435-6.526a6.749,6.749,0,0,0-5.616-6.563V1.354a1.4,1.4,0,0,0-2.807,0v.882A6.749,6.749,0,0,0,2.813,8.8c0,4.327-1.587,5.648-2.435,6.526A1.3,1.3,0,0,0,0,16.243,1.38,1.38,0,0,0,1.409,17.6H18.255a1.38,1.38,0,0,0,1.409-1.354A1.3,1.3,0,0,0,19.286,15.325Z"
    />
  </svg>
);

const iconMapByText = {
  dashboard: DashboardIcon,
  projects: ProjectIcon,
  project: ProjectIcon,
  deals: AssetsIcon,
  assets: AssetsIcon,
  availability: AvailableIcon,
  "land & seller": HomeIcon,
  "land and seller": HomeIcon,
  units: HomeIcon,
  cases: HomeIcon,
  home: HomeIcon,
  vouchers: PayrollIcon,
  payroll: PayrollIcon,
  "chart of acc.": ChartIcon,
  "chart of accounts": ChartIcon,
  tax: TaxIcon,
  investment: LoanIcon,
  loan: LoanIcon,
  reports: ReportIcon,
  report: ReportIcon,
  analytics: AnalyticsIcon,
  ledger: LedgerIcon,
  accounts: LedgerIcon,
  attendence: LedgerIcon,
  employees: EmployeeIcon,
  employee: EmployeeIcon,
  broker: BrokerIcon,
  brokers: BrokerIcon,
  leads: BrokerIcon,
  lead: LeadIcon,
  tasks: TaskIcon,
  task: TaskIcon,
  settings: MaintenanceIcon,
  maintenance: MaintenanceIcon,
  roles: BrokerIcon,
  users: PersonIcon,
  user: PersonIcon,
  approvals: TaskIcon,
  tags: TodoListIcon,
  todolist: TodoListIcon,
  whatsapp: WhatsappIcon,
  automation: ReportIcon,
  profile: PersonIcon,
  contractors: PersonIcon,
  vendors: AssetsIcon,
  material: AvailableIcon,
  configuration: AssetsIcon,
  "gate pass": TaskIcon,
  "change request": DashboardIcon,
  "revert vouchers": LedgerIcon,
  "revert back vouchers": LedgerIcon,
  depreciation: DepreciationIcon,
};

const ICON_SRC_MATCHERS = [
  { match: "dashboard", icon: DashboardIcon },
  { match: "project", icon: ProjectIcon },
  { match: "assets", icon: AssetsIcon },
  { match: "available", icon: AvailableIcon },
  { match: "home", icon: HomeIcon },
  { match: "ledger", icon: LedgerIcon },
  { match: "chart", icon: ChartIcon },
  { match: "tax", icon: TaxIcon },
  { match: "loan", icon: LoanIcon },
  { match: "report", icon: ReportIcon },
  { match: "payroll", icon: PayrollIcon },
  { match: "employee", icon: EmployeeIcon },
  { match: "broker", icon: BrokerIcon },
  { match: "leads", icon: BrokerIcon },
  { match: "lead", icon: LeadIcon },
  { match: "tasks", icon: TaskIcon },
  { match: "person", icon: PersonIcon },
  { match: "depriciation", icon: DepreciationIcon },
  { match: "maintenence", icon: MaintenanceIcon },
  { match: "todolist", icon: TodoListIcon },
  { match: "whatsup", icon: WhatsappIcon },
  { match: "analytics", icon: AnalyticsIcon },
  { match: "payable", icon: PayableIcon },
  { match: "bell", icon: BellIcon },
];

/**
 * Returns a React SVG icon matching the given icon element, src string, or menu text.
 * Falls back cleanly to DashboardIcon if unspecified.
 */
export const getMenuIconComponent = (iconElementOrSrc, text = "") => {
  // If it's already an inline SVG element (e.g. from MenuIcons), return it directly
  if (React.isValidElement(iconElementOrSrc)) {
    if (iconElementOrSrc.type === "svg" || iconElementOrSrc.type?.name?.endsWith("Icon")) {
      return null; // Signals to use as-is
    }
    // If it's an <img> tag, inspect its src or alt
    if (iconElementOrSrc.type === "img") {
      const src = (iconElementOrSrc.props.src || "").toLowerCase();
      const alt = (iconElementOrSrc.props.alt || "").toLowerCase();

      const matched = ICON_SRC_MATCHERS.find((item) => src.includes(item.match));
      if (matched) {
        return matched.icon;
      }

      if (alt && iconMapByText[alt]) {
        return iconMapByText[alt];
      }
    }
  }

  const cleanText = (text || "").toLowerCase().trim();
  if (cleanText && iconMapByText[cleanText]) {
    return iconMapByText[cleanText];
  }

  return DashboardIcon;
};

/**
 * Helper to render menu icon seamlessly with inherited currentColor.
 */
export const renderMenuIcon = (iconProp, text = "") => {
  if (React.isValidElement(iconProp)) {
    if (iconProp.type === "svg" || iconProp.type?.name?.endsWith("Icon")) {
      return iconProp;
    }
    if (iconProp.type === "img") {
      const MatchedIcon = getMenuIconComponent(iconProp, text);
      if (MatchedIcon) {
        return <MatchedIcon className={iconProp.props.className || "ml-3 Icondashboard"} />;
      }
    }
  }

  const MatchedIcon = getMenuIconComponent(iconProp, text);
  return <MatchedIcon className="ml-3 Icondashboard" />;
};
